<template>
    <el-row class="tac">
      <el-col :span="12">
        
        <el-icon><Menu /></el-icon>
        <el-menu
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          style="width:200%"
        >
          <el-sub-menu index="1" v-if="$store.state.user.roles && ($store.state.user.roles.includes('teacher') || $store.state.user.roles.includes('admin'))">
            <template #title>
              <el-icon><Collection /></el-icon>
              <span>课程管理</span>
            </template>
            <el-menu-item index="1-1" v-if="$store.state.user.roles && ($store.state.user.roles.includes('teacher'))">
                <router-link class="nav-link" :to="{ name: 'CourseList', params: { page: 1 } }">课程列表</router-link>
            </el-menu-item>
            <el-menu-item-group title="管理员(可见)" v-if="$store.state.user.roles && ($store.state.user.roles.includes('admin'))">
              <el-menu-item index="1-2">
                <router-link class="nav-link" :to="{ name: 'CourseAllView', params:{page: 1, cateId: 0, courseName: '' } }">全部课程</router-link>
            </el-menu-item>
            </el-menu-item-group>
          </el-sub-menu>
          <el-menu-item index="2" v-if="$store.state.user.roles && ($store.state.user.roles.includes('admin'))">
            <el-icon><FolderOpened /></el-icon>
            <span> <router-link class="nav-link" :to="{ name: 'CateView', params: { page: 1 } }">分类管理</router-link></span>
          </el-menu-item>

          <el-menu-item index="3" v-if="$store.state.user.roles && ($store.state.user.roles.includes('admin'))">
            <el-icon><Postcard /></el-icon>
            <span> <router-link class="nav-link" :to="{ name: 'ProfessionalCertifica', params: { page: 1, keyword: '' } }">专业证书</router-link></span>
          </el-menu-item>

          <el-sub-menu index="4" v-if="$store.state.user.roles && $store.state.user.roles.includes('admin')">
            <template #title>
              <el-icon><User /></el-icon>
              <span>用户管理</span>
            </template>
            <el-menu-item-group title="管理员(可见)" v-if="$store.state.user.roles && ($store.state.user.roles.includes('admin'))">
              <el-menu-item index="4-1">
                <router-link class="nav-link" :to="{ name: 'AllUser', params: {page: 1, keyword: ''}}">全部用户</router-link>
            </el-menu-item>
              <el-menu-item index="4-2">
                <router-link class="nav-link" :to="{ name: 'BatchAddStu'}">批量添加学生</router-link>
              </el-menu-item>
              <el-menu-item index="4-3">
                <router-link class="nav-link" :to="{ name: 'BatchAddTea'}">批量添加教师</router-link>  
              </el-menu-item>
            </el-menu-item-group>
          </el-sub-menu>
          <el-menu-item index="5" v-if="$store.state.user.roles && ($store.state.user.roles.includes('admin'))">
            <el-icon><Setting /></el-icon>
            <span> <router-link class="nav-link" :to="{ name: 'OptionView' }">网站配置</router-link></span>
          </el-menu-item>
          <el-menu-item index="6">
            <el-icon><DArrowLeft /></el-icon>
            <span><router-link class="nav-link" :to="{ name: 'home' }">回到首页</router-link></span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </template>
  

<script setup>

</script>

<style>
</style>